const columns = [
    'id',
    {
        headerText: 'Model', key: 'model', dataType: 'string', readOnly: true 
    },
    {
        headerText: 'Product Type', key: 'styleDescription', dataType: 'string', readOnly: true
    },
    {
        headerText: 'Tag', key: 'tag', dataType: 'string', readOnly: false, maxLength: 15
    },
    {
        headerText: 'Quantity',
        key: 'quantity',
        format: 'int',
        maxLength: 5,
        minValue: 1,
        maxValue: 99999,
        readOnly: false,
        dataType: 'number',
        resizing: true,
        allowTooltips: true,
        filtering: true,
        sorting: true,
        width: '90'
    },
    {
        headerText: 'Width (in.)', key: 'selectedWidth', dataType: 'number', readOnly: true
    },
    {
        headerText: 'Height (in.)', key: 'selectedHeight', dataType: 'number', readOnly: true
    },
    {
        headerText: 'Flow (CFM)', key: 'selectedAirFlow', dataType: 'string', readOnly: true
    },
    {
        headerText: 'Application', key: 'selectedFlowDirection', dataType: 'string', readOnly: true, formatter: ApplicationtFormatter
    },
    {
        headerText: 'Free Area (ft²)', key: 'freeArea', dataType: 'number', readOnly: true
    },
    {
        headerText: 'Free Area %', key: 'freeAreaPerc', dataType: 'number', readOnly: true
    },
    {
        headerText: 'Free Area Vel (fpm)', key: 'freeAreaVelocity', dataType: 'number', readOnly: true
    },
    {
        headerText: 'Pressure Drop (in. wg)', key: 'pressureDrop', dataType: 'number', readOnly: true, width: '90'
    },
    {
        headerText: 'Beginning Water Pen. (fpm)', key: 'begWaterPen', dataType: 'number', readOnly: true, formatter: NotApplicableFormatter
    },
    // {
    //     headerText: 'Water Pen Safety Factor', key: 'waterPenSafFac', dataType: 'number', readOnly: true, formatter: NotApplicableFormatter
    // },
    {
        headerText: 'Class A 29 MPH Wind VEL (fpm)', key: 'lowWeather', dataType: 'number', width: '90', readOnly: true, formatter: NotApplicableFormatter
    },
    {
        headerText: 'Class A 50 MPH Wind VEL (fpm)', key: 'highWeather', dataType: 'number', width: '90', readOnly: true, formatter: NotApplicableFormatter
    },
    {
        headerText: 'Max Exhaust (fpm)', key: 'maxExhVelFPM', dataType: 'number', readOnly: true, formatter: MaxExhaustFormatter
    },
    // {
    //     headerText: 'Sect. Width', key: 'width', dataType: 'string', width: '90', allowTooltips: false, readOnly: true
    // },
    // {
    //     headerText: 'Sect. Height', key: 'height', dataType: 'string', width: '90', allowTooltips: false, readOnly: true
    // },
    {
        headerText: 'Comment', key: 'comment', dataType: 'string', readOnly: false, maxLength: 100, width: '750'
    }

];

export default columns;

function NotApplicableFormatter(val) {
    if (val === null || val === 0) {
        val = 'N/A';
    }
    return val;
}

function MaxExhaustFormatter(val, row) {
    let maxexhaust = val;
    if (row !== undefined) {
        if (row.selectedFlowDirection === "I" || val === 0)
            maxexhaust = 'N/A';
        else
            maxexhaust = val;
    }
    return maxexhaust;
}

function ApplicationtFormatter(val, row) {
    let application = val;
    if (row !== undefined) {
        if (row.selectedFlowDirection === "I" || row.selectedFlowDirection ==='Intake' || val === 0)
        {
            application = 'Intake';
            row.selectedFlowDirection ='Intake';
        }
        else
        {
            application = 'Exhaust';
            row.selectedFlowDirection ='Exhaust';
        }
    }
    return application;
}